import { ProductLine } from 'src/viewModels/Products';
import LogoIllustrator from '../../assets/svg/modul_icon_AdobeIllustrator.svg';
import LogoColorCard from '../../assets/svg/modul_icon_ColorCard.svg';
import LogoColorProof from '../../assets/svg/modul_icon_ColorProof.svg';
import LogoCPGO from '../../assets/svg/modul_icon_ColorProofGo.svg';
import LogoColorServer from '../../assets/svg/modul_icon_ColorServer.svg';
import LogoMeasure from '../../assets/svg/modul_icon_Measure.svg';
import LogoOpenColor from '../../assets/svg/modul_icon_OpenColor.svg';
import LogoOptimize from '../../assets/svg/modul_icon_Optimize.svg';
import LogoProofControl from '../../assets/svg/modul_icon_ProofControl.svg';
import LogoPhotoShop from '../../assets/svg/modul_icon_Ps.svg';

export type HelpDeskUrl = {
    en: string;
    de: string;
};

interface ProductConfig {
    name: string;
    logo: React.ReactNode;
    helpDeskUrl: HelpDeskUrl;
}

// TODO: helpdesk article id should be removed and be part of the the query from BE
export const helpDeskArticleIdsByProductLine = new Map<ProductLine, { en: string; de: string } | undefined>([
    ['Optimize', { en: '', de: '' }],
    ['Measure', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/38284023559451',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/38284023559451',
    }],
    ['ColorProof', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/4570658872219',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/4570658872219',
    }],
    ['ColorServer', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/13521335026715',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/13521335026715',
    }],
    ['OpenColor', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/13073843675547',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/13073843675547',
    }],
    ['ProofControl', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/17122859200795',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/17122859200795',
    }],
    ['ColorProofGO', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/18584159325851',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/18584159325851',
    }],
    ['PhotoshopPlugin', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/17244768671899',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/17244768671899',
    }],
    ['VectorPlugin', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/26556216292763',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/26556216292763',
    }],
    ['ColorCard', {
        en: 'https://customercare.gmgcolor.com/hc/en-us/categories/18904021199003',
        de: 'https://customercare.gmgcolor.com/hc/de-de/categories/18904021199003',
    }],
]);

export const productNamesByProductLine = new Map<ProductLine, string>([
    ['Optimize', 'GMG Optimize incl. GMG Measure'],
    ['ColorCard', 'GMG ColorCard'],
    ['Measure', 'GMG Measure'],
    ['PhotoshopPlugin', 'GMG ColorPlugin for Adobe® Photoshop®'],
    ['VectorPlugin', 'GMG ColorPlugin for Adobe® Illustrator®'],
    ['ColorServer', 'GMG ColorServer'],
    ['ProofControl', 'GMG ProofControl'],
    ['ColorProof', 'GMG ColorProof'],
    ['ColorProofGO', 'GMG ColorProof GO'],
    ['OpenColor', 'GMG OpenColor'],
]);

export const productConfigByProductLine = new Map<ProductLine, ProductConfig>([
    ['Optimize', {
        logo: <LogoOptimize width={48} height={48} />,
        name: productNamesByProductLine.get('Optimize')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('Optimize')!,
    }],
    ['ColorCard', {
        logo: <LogoColorCard width={48} height={48} />,
        name: productNamesByProductLine.get('ColorCard')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('ColorCard')!,
    }],
    ['Measure', {
        logo: <LogoMeasure width={48} height={48} />,
        name: productNamesByProductLine.get('Measure')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('Measure')!,
    }],
    ['PhotoshopPlugin', {
        logo: <LogoPhotoShop width={48} height={48} />,
        name: productNamesByProductLine.get('PhotoshopPlugin')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('PhotoshopPlugin')!,
    }],
    ['VectorPlugin', {
        logo: <LogoIllustrator width={48} height={48} />,
        name: productNamesByProductLine.get('VectorPlugin')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('VectorPlugin')!,
    }],
    ['ColorServer', {
        logo: <LogoColorServer width={48} height={48} />,
        name: productNamesByProductLine.get('ColorServer')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('ColorServer')!,
    }],
    ['ProofControl', {
        logo: <LogoProofControl width={48} height={48} />,
        name: productNamesByProductLine.get('ProofControl')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('ProofControl')!,
    }],
    ['ColorProof', {
        logo: <LogoColorProof width={48} height={48} />,
        name: productNamesByProductLine.get('ColorProof')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('ColorProof')!,
    }],
    ['ColorProofGO', {
        logo: <LogoCPGO width={48} height={48} />,
        name: productNamesByProductLine.get('ColorProofGO')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('ColorProofGO')!,
    }],
    ['OpenColor', {
        logo: <LogoOpenColor width={48} height={48} />,
        name: productNamesByProductLine.get('OpenColor')!,
        helpDeskUrl: helpDeskArticleIdsByProductLine.get('OpenColor')!,
    }],
]);